interface NumberSpecs {
    stringifiedNumber: string;
    decimalSeparator: string;
    thousandsSeparator: string;
}

export function formatNumber(numberSpecs: NumberSpecs): string {
    let afterPoint = "";
    if (numberSpecs.stringifiedNumber.indexOf(".") > 0)
        afterPoint =
            numberSpecs.decimalSeparator +
            numberSpecs.stringifiedNumber.substring(
                numberSpecs.stringifiedNumber.indexOf(".") + 1,
                numberSpecs.stringifiedNumber.length
            );
    const parsedNumber = Number(numberSpecs.stringifiedNumber);
    if (isNaN(parsedNumber)) return "";
    let numberCopy = Math.floor(parsedNumber).toString();
    const numbersArray = [];
    const firstNumbers = numberCopy.length % 3;
    if (firstNumbers !== 0)
        numbersArray.push(numberCopy.substring(0, firstNumbers));
    for (let i = firstNumbers; i < numberCopy.length; i = i + 3) {
        numbersArray.unshift(numberCopy.substring(i, i + 3));
    }
    const number =
        numbersArray.length > 1
            ? numbersArray.reverse().join(numberSpecs.thousandsSeparator)
            : numbersArray.toString();
    return number + afterPoint;
}
